import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Checkbox } from 'semantic-ui-react';
import InstantBookPricingPopup from './InstantBookPricingPopup/InstantBookPricingPopup';

const InstantBook = ({
  handleUpdateInstantBookInfo,
  handleToggleInstantBooking,
  instantBookInfo,
  instantBook,
}) => (
  <div className="bg-white shadow-mid d-flex align-self-stretch p-4">
    <div className="row align-self-stretch">
      <div className="col">
        <p className="t-21 font-weight-bold text-darkgreen">Instant Book</p>
      </div>
      <div className="col-12">
        <p className="t-13 mt-4">
          Allow clients to automatically book your time without needing your
          approval.
        </p>
      </div>
      <div className="col-12">
        <div className="mx-auto my-3 custom-checkbox-key custom-checkbox-key-on">
          <div className="legend">Off</div>
          <Checkbox
            toggle
            name="instant-book"
            onChange={handleToggleInstantBooking}
            defaultChecked={instantBook}
          />
          <div className={classNames('legend', instantBook && 'text-teal-2')}>
            On
          </div>
        </div>
      </div>
      <div className="col-12">
        <p className="t-12 text-gray mb-3">
          Turning this On will open you up to more projects, but will require
          your schedule to be up to date.
        </p>
      </div>
      <div className="col-12 text-right align-self-end">
        <InstantBookPricingPopup
          instantBookInfo={instantBookInfo}
          handleUpdateInstantBookInfo={handleUpdateInstantBookInfo}
        />
      </div>
    </div>
  </div>
);

InstantBook.propTypes = {
  handleToggleInstantBooking: PropTypes.func,
  handleUpdateInstantBookInfo: PropTypes.func,
  instantBook: PropTypes.bool,
  instantBookInfo: PropTypes.array,
};

export default InstantBook;



// WEBPACK FOOTER //
// ./src/components/DashboardFreelancerMain/InstantBook/InstantBook.js